import { useSelector } from "react-redux";
import { FeatureResponseDto, OnDataFeature } from "~/gen/api/user";
import { getUserProfile } from "~/reducers/userProfile";


const c_key = 'od_features'

export const useHasFeature = () => {
  return useSelector(store => {
    const features = getUserProfile(store)?.features ?? getCachedFeatures() as FeatureResponseDto[];
    window.sessionStorage.setItem(c_key, JSON.stringify(features.map(x => ({featureId: x.featureId}))))
    return {
      OnDataDriver: features.some(f => f.featureId === OnDataFeature.OnDataDriver),
      OnDataSecureFile: features.some(f => f.featureId === OnDataFeature.OnDataSecureFile),
    }
  })
}

const getCachedFeatures = () => {
  try {
    const fs = JSON.parse(window.sessionStorage.getItem(c_key) || '[]')
    return (fs instanceof Array) ? fs : []
  } catch {
    return []
  }
}